import ProductCarousel from './productCarousel'

export default ProductCarousel
